import { Link } from "@tanstack/react-router";
import type { Crumb } from "@/lib/jsonld";

export type { Crumb } from "@/lib/jsonld";
export { breadcrumbJsonLd } from "@/lib/jsonld";

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex flex-wrap items-center text-[0.8125rem] text-muted-foreground">
        {items.map((c, i) => {
          const last = i === items.length - 1;
          return (
            <li key={c.path} className="flex items-center">
              {last ? (
                <span aria-current="page" className="text-foreground/80">
                  {c.name}
                </span>
              ) : (
                <Link to={c.path} className="underline-offset-4 hover:text-primary hover:underline">
                  {c.name}
                </Link>
              )}
              {!last && (
                <span aria-hidden className="mx-2 text-border">
                  /
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
